var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.112,
    height: 21.733,
    viewBox: "0 0 23.112 21.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(-366.985 -720.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43",
    transform: "translate(366.985 720.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_42",
    "data-name": "Grupo 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M-763.753,792.545l-15.221-7.106c.224.9.438,1.682.61,2.473.239,1.093-.333,1.906-1.3,1.868a1.3,1.3,0,0,1-1.294-1.069q-.667-2.59-1.292-5.19a1.4,1.4,0,0,1,.387-1.53,1.448,1.448,0,0,1,1.636-.12q10.031,4.683,20.062,9.363a1.414,1.414,0,0,1,.957,1.323,1.444,1.444,0,0,1-.982,1.31q-10,4.66-20,9.332a1.457,1.457,0,0,1-1.7-.125,1.438,1.438,0,0,1-.333-1.607q1.294-4.554,2.6-9.1a1.428,1.428,0,0,1,1.6-1.178q2.5-.016,5.01,0c.962.008,1.52.534,1.513,1.376s-.568,1.335-1.547,1.344c-1.234.011-2.469-.009-3.7.015-.195,0-.518.13-.559.268-.53,1.744-1.019,3.5-1.562,5.41Z",
    transform: "translate(782.316 -781.677)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/submit-icon.13898fb202062013afc850ffc17a0dc8.svg";
export { ForwardRef as ReactComponent };